import type { TableColumns } from '@ohpen/enso-ui';
import { BdmResponse, RegionResponse } from '@pmp/api';

// The linked-entity columns resolve ids -> names through the table's valueLists
// (BDMS_LIST / REGIONS_LIST).
export type RegionRow = RegionResponse;
export type BdmRow = BdmResponse;

export const BDMS_LIST = 'bdms';
export const REGIONS_LIST = 'regions';

const labels = 'lender.regionsBdms.labels';

export const regionColumns: TableColumns<RegionRow> = [
  {
    title: 'global.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 300,
    options: { filter: 'search', sorter: true, hide: true },
  },
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    key: 'name',
    width: 330,
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.linkedBdms`,
    dataIndex: 'bdmIds',
    key: 'bdmIds',
    width: 400,
    options: {
      filter: 'select',
      format: { type: 'multiValueList', ellipsis: { visibleItems: 12 } },
      listName: BDMS_LIST,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const bdmColumns: TableColumns<BdmRow> = [
  {
    title: 'global.labels.id',
    dataIndex: 'id',
    key: 'id',
    width: 300,
    options: { filter: 'search', sorter: true, hide: true },
  },
  {
    title: `${labels}.name`,
    dataIndex: 'name',
    key: 'name',
    width: 250,
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.contactNumber`,
    dataIndex: 'contactNumber',
    key: 'contactNumber',
    width: 190,
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.description`,
    dataIndex: 'description',
    key: 'description',
    width: 150,
    options: { filter: 'search', sorter: true },
  },
  {
    title: `${labels}.linkedRegions`,
    dataIndex: 'regionIds',
    key: 'regionIds',
    width: 250,
    options: {
      filter: 'select',
      format: { type: 'multiValueList', ellipsis: { visibleItems: 2 } },
      listName: REGIONS_LIST,
    },
  },
  { title: 'enso.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];
